module.exports = __webpack_public_path__ + "static/Robert_350x350-e378b8980e22ad1bbb78a2b0967acb88.png";